<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4></h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group">
      <input
          #fileInput
          type="file"
          class="form-control"
          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
          (change)="onFileChange($event)"
          multiple
      />
      <div *ngIf="isLoading" style="width: 100px; margin: 0 auto">
        <p>
          Uploading...
        </p>
        <p-progressSpinner></p-progressSpinner>
      </div>
      <ng-container *ngIf="!isLoading">
        <p>
          Selected Files:
        </p>
        <div *ngIf="!selectedRamsFiles.length">
          none
        </div>
        <ul *ngIf="selectedRamsFiles.length">
          <li *ngFor="let file of selectedRamsFiles; let i = index">
            {{ file.name }}
            <button type="button" class="btn btn-primary btn-link text-left link-underline" (click)="viewSelectedDocument(file)">
              <i class="fas fa-search"></i>
              View
            </button>
            <button type="button" class="btn btn-link btn-danger link-underline" (click)="removeSelectedDocument(i)">
              <i class="fas fa-close"></i>
              Remove
            </button>
          </li>
        </ul>
        <button type="button" class="btn btn-primary btn-sm work-order-button" (click)="fileInput.click()">Attach more</button>
      </ng-container>
    </div>
  </form>
  <p-footer *ngIf="!isLoading">
    <button type="button" (click)="onSubmit()" [disabled]="!selectedRamsFiles.length" class="btn btn-sm btn-success">Upload</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
